/* eslint-disable no-restricted-syntax */
import { all, call, put, takeLatest, takeLeading, } from 'redux-saga/effects';

import * as apicore from "services/core";
import * as type from './constant';
import * as action from './action';

function* getListItems({ params, selfRole }) {
  try {

    const data = [];
    let p = 0;
    let tp = 0;
    do {
      const { results, page, totalPages } = yield call(apicore.getUserRequest, { ...params, page: p + 1, limit: 50 }, selfRole);
      data.push(...results)
      p = page;
      tp = totalPages;
    } while (p < tp);
    yield put(action.getUserSuccess(data));

  } catch (error) {
    yield put(action.getUserError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* addItem({ payload, selfRole }) {
  try {

    const response = yield call(apicore.addUserRequest, payload, selfRole);
    yield put(action.addUserSuccess(response));

  } catch (error) {
    yield put(action.manipulationUserError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* updateItem({ id, payload, selfRole }) {
  try {

    const response = yield call(apicore.updateUserRequest, id, payload, selfRole);
    yield put(action.updateUserSuccess(response));

  } catch (error) {
    yield put(action.manipulationUserError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* deleteItem({ ids, selfRole }) {
  try {

    for (const id of ids) {
      yield call(apicore.deleteUserRequest, id, selfRole);
    }
    
    yield put(action.deleteUserSuccess(true));

  } catch (error) {
    yield put(action.manipulationUserError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* getPermissions({ role }) {
  try {

    const response = yield call(apicore.getUserPermissionRequest, { role });
    yield put(action.getUserPermissionSuccess(response, role));

  } catch (error) {
    yield put(action.manipulationUserError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* restoreDefaultPermissions({ ids }) {
  try {

    for (const id of ids) {
      yield call(apicore.restoreUserDefaultPermissionsRequest, id);
    }
    
    yield put(action.restoreUserPermissionSuccess(true));

  } catch (error) {
    yield put(action.manipulationUserError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

function* generatePasswordlessToken({ id }) {
  try {

    const response = yield call(apicore.generatePasswordlessTokenRequest, id);
    yield put(action.generateUserPasswordlessTokenSuccess(id, response));

  } catch (error) {
    yield put(action.manipulationUserError(error?.response?.data?.message || error?.response?.statusText || error.toString()));
  }
}

export function* watchGetList() {
  yield takeLatest(type.GET, getListItems);
}
export function* watchAddList() {
  yield takeLeading(type.ADD, addItem);
}
export function* watchUpdateItem() {
  yield takeLeading(type.UPDATE, updateItem);
}
export function* watchDeleteItem() {
  yield takeLeading(type.DELETE, deleteItem);
}
export function* watchGetPermissions() {
  yield takeLatest(type.GET_PERMISSION, getPermissions);
}
export function* watchRestoreDefaultPermissions() {
  yield takeLatest(type.RESTORE_PERMISSIONS, restoreDefaultPermissions);
}
export function* watchGeneratePasswordlessToken() {
  yield takeLeading(type.PASSWORDLESS_TOKEN, generatePasswordlessToken);
}

export default function* rootSaga() {
  yield all([
    watchGetList(),
    watchUpdateItem(),
    watchAddList(),
    watchDeleteItem(),
    watchGetPermissions(),
    watchRestoreDefaultPermissions(),
    watchGeneratePasswordlessToken(),
  ]);
}
